import { useContext } from 'react'

import { ThemeContext } from './ThemeContext'

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme должен вызываться внутри ThemeProvider')
  return context
}
